import React, {useState} from "react";
import {safeUrl} from "../sectionText";

// Bouton : « inscription » (valeur par défaut) ouvre l'inscription ; « lien » exige un lien interne ou https://.
export function ButtonBlock({data, ctx}) {
    const style = data.style === "ghost" ? "btn-ghost" : "btn-primary";
    if (data.target === "link") {
        const href = safeUrl(data.url, null);
        if (!href || !data.label) return null;
        return <p className="block-button"><a className={`btn ${style}`} href={href}>{data.label}</a></p>;
    }
    return (
        <p className="block-button">
            <button type="button" className={`btn ${style}`} onClick={ctx.onRegister}>{data.label || "S'inscrire"}</button>
        </p>
    );
}

// Invite à parler de la plateforme à un·e collègue : copie le lien du site (aucune donnée personnelle).
export function InviteColleagueBlock({data}) {
    const [state, setState] = useState("idle");

    async function copy() {
        try {
            await navigator.clipboard.writeText(window.location.origin);
            setState("copied");
        } catch {
            setState("failed");
        }
    }

    return (
        <div className="block-invite custom-card">
            {data.title && <strong>{data.title}</strong>}
            {data.text && <p>{data.text}</p>}
            <button type="button" className="btn btn-ghost" onClick={copy}>{data.button_label || "Copier le lien du site"}</button>
            {state === "copied" && <p role="status" className="block-invite__status">Lien copié ✓</p>}
            {state === "failed" && <p role="status" className="block-invite__status">Copiez ce lien : {window.location.origin}</p>}
        </div>
    );
}
